module.exports = __webpack_public_path__ + "img/icon_quit.aa2db4b0.svg";